// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Card shell ───────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-card {
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  background: var(--neutralcolors-100);
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ── Header ───────────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-header {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 20px;
  height: 56px;
  background: var(--neutralcolors-100);
  border-bottom: 1px solid var(--neutralcolors-400);
  flex-shrink: 0;
  border-radius: 5px 5px 0 0;
  overflow: hidden;
}

.scl--cms-components-inboxChart-title {
  background: none;
  border: none;
  padding: 5px 20px 5px 0px;
  cursor: pointer;
  font-family: var(--font-family-inter), sans-serif;
  font-weight: 600;
  font-size: var(--font-size-18);
  line-height: var(--line-height-24);
  letter-spacing: -0.01em;
  color: var(--typography-text-body-primary);
  text-align: left;
  text-decoration: none;
}

.scl--cms-components-inboxChart-title:hover {
  text-decoration: underline;
}

/* ── Body ─────────────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 20px 16px;
  gap: 80px;
  flex: 1;
  min-height: 0;
  overflow: visible;
}

.scl--cms-components-inboxChart-donutWrap {
  position: relative;
  width: 260px;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: default;
  overflow: visible;
}

/* ── Center text overlay ──────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  pointer-events: none;
}

.scl--cms-components-inboxChart-centerLabel {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-20);
  color: var(--typography-text-body-secondary);
  text-align: center;
}

.scl--cms-components-inboxChart-centerValue {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: 600;
  font-size: var(--font-size-36);
  line-height: var(--line-height-40);
  color: var(--typography-text-body-primary);
  text-align: center;
}

.scl--cms-components-inboxChart-centerSub {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-20);
  color: var(--typography-text-body-secondary);
  text-align: center;
}

/* ── Tooltip ──────────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-tooltip {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--neutralcolors-100);
  border: 1px solid var(--neutralcolors-400);
  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);
  border-radius: 3px;
  padding: 5px 8px;
  font-family: var(--font-family-inter);
  font-weight: 600;
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--neutralcolors-700);
  white-space: nowrap;
  pointer-events: none;
  z-index: 100;
  transition: opacity 0.2s ease, top 0.25s ease, left 0.25s ease;
}

.scl--cms-components-inboxChart-tooltipBeak {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid var(--neutralcolors-400);
}

.scl--cms-components-inboxChart-tooltipBeak::after {
  content: '';
  position: absolute;
  top: -7px;
  left: -5px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid var(--neutralcolors-100);
}

/* ── Legend pills ─────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-legend {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
}

.scl--cms-components-inboxChart-legendItem {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 6px;
  background: var(--neutralcolors-200);
  border: 1px solid var(--neutralcolors-300);
  border-radius: 6px;
}

.scl--cms-components-inboxChart-legendDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.scl--cms-components-inboxChart-legendName {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--neutralcolors-800);
  white-space: nowrap;
}

.scl--cms-components-inboxChart-legendCount {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-12);
  line-height: var(--line-height-18);
  color: var(--neutralcolors-700);
  text-align: right;
}

/* ── Footer ───────────────────────────────────────────────────────────────── */

.scl--cms-components-inboxChart-footer {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px 10px;
  height: 51px;
  background: var(--neutralcolors-100);
  border-top: 1px solid var(--neutralcolors-400);
  flex-shrink: 0;
  border-radius: 0 0 5px 5px;
  overflow: hidden;
}

.scl--cms-components-inboxChart-footerLink {
  font-family: var(--font-family-inter), sans-serif;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  letter-spacing: -0.1px;
  color: var(--primarypalette-blue);
  text-decoration: none;
}

.scl--cms-components-inboxChart-footerLink:hover {
  text-decoration: underline;
}

.scl--cms-components-inboxChart-openBtn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-family-inter), sans-serif;
  font-weight: 600;
  font-size: var(--font-size-14);
  line-height: var(--line-height-20);
  color: var(--secondarycolors-blue400);
  padding: 0;
  flex-shrink: 0;
  text-decoration: none;
}

.scl--cms-components-inboxChart-openBtn:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/inbox-dsb-op/inbox-chart/css/inboxChart.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,WAAW;EACX,OAAO;EACP,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,iDAAiD;EACjD,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,OAAO;EACP,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA,gFAAgF;;AAEhF;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,0CAA0C;EAC1C,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,8DAA8D;AAChE;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA,gFAAgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,8CAA8C;EAC9C,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,uCAAuC;EACvC,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iDAAiD;EACjD,gBAAgB;EAChB,8BAA8B;EAC9B,kCAAkC;EAClC,qCAAqC;EACrC,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["/* ── Card shell ───────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-card {\n  box-sizing: border-box;\n  width: 100%;\n  flex: 1;\n  background: var(--neutralcolors-100);\n  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.04);\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* ── Header ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-header {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 16px 20px;\n  height: 56px;\n  background: var(--neutralcolors-100);\n  border-bottom: 1px solid var(--neutralcolors-400);\n  flex-shrink: 0;\n  border-radius: 5px 5px 0 0;\n  overflow: hidden;\n}\n\n.scl--cms-components-inboxChart-title {\n  background: none;\n  border: none;\n  padding: 5px 20px 5px 0px;\n  cursor: pointer;\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: 600;\n  font-size: var(--font-size-18);\n  line-height: var(--line-height-24);\n  letter-spacing: -0.01em;\n  color: var(--typography-text-body-primary);\n  text-align: left;\n  text-decoration: none;\n}\n\n.scl--cms-components-inboxChart-title:hover {\n  text-decoration: underline;\n}\n\n/* ── Body ─────────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 24px 20px 16px;\n  gap: 80px;\n  flex: 1;\n  min-height: 0;\n  overflow: visible;\n}\n\n.scl--cms-components-inboxChart-donutWrap {\n  position: relative;\n  width: 260px;\n  height: 260px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  cursor: default;\n  overflow: visible;\n}\n\n/* ── Center text overlay ──────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-center {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  pointer-events: none;\n}\n\n.scl--cms-components-inboxChart-centerLabel {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-20);\n  color: var(--typography-text-body-secondary);\n  text-align: center;\n}\n\n.scl--cms-components-inboxChart-centerValue {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: 600;\n  font-size: var(--font-size-36);\n  line-height: var(--line-height-40);\n  color: var(--typography-text-body-primary);\n  text-align: center;\n}\n\n.scl--cms-components-inboxChart-centerSub {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-20);\n  color: var(--typography-text-body-secondary);\n  text-align: center;\n}\n\n/* ── Tooltip ──────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-tooltip {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: var(--neutralcolors-100);\n  border: 1px solid var(--neutralcolors-400);\n  box-shadow: 0px 0.735px 2.94px rgba(25, 33, 61, 0.08);\n  border-radius: 3px;\n  padding: 5px 8px;\n  font-family: var(--font-family-inter);\n  font-weight: 600;\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--neutralcolors-700);\n  white-space: nowrap;\n  pointer-events: none;\n  z-index: 100;\n  transition: opacity 0.2s ease, top 0.25s ease, left 0.25s ease;\n}\n\n.scl--cms-components-inboxChart-tooltipBeak {\n  position: absolute;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-top: 6px solid var(--neutralcolors-400);\n}\n\n.scl--cms-components-inboxChart-tooltipBeak::after {\n  content: '';\n  position: absolute;\n  top: -7px;\n  left: -5px;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n  border-top: 5px solid var(--neutralcolors-100);\n}\n\n/* ── Legend pills ─────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-legend {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.scl--cms-components-inboxChart-legendItem {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px;\n  gap: 6px;\n  background: var(--neutralcolors-200);\n  border: 1px solid var(--neutralcolors-300);\n  border-radius: 6px;\n}\n\n.scl--cms-components-inboxChart-legendDot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.scl--cms-components-inboxChart-legendName {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--neutralcolors-800);\n  white-space: nowrap;\n}\n\n.scl--cms-components-inboxChart-legendCount {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-12);\n  line-height: var(--line-height-18);\n  color: var(--neutralcolors-700);\n  text-align: right;\n}\n\n/* ── Footer ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-inboxChart-footer {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 10px;\n  height: 51px;\n  background: var(--neutralcolors-100);\n  border-top: 1px solid var(--neutralcolors-400);\n  flex-shrink: 0;\n  border-radius: 0 0 5px 5px;\n  overflow: hidden;\n}\n\n.scl--cms-components-inboxChart-footerLink {\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: var(--font-weight-regular);\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  letter-spacing: -0.1px;\n  color: var(--primarypalette-blue);\n  text-decoration: none;\n}\n\n.scl--cms-components-inboxChart-footerLink:hover {\n  text-decoration: underline;\n}\n\n.scl--cms-components-inboxChart-openBtn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-family: var(--font-family-inter), sans-serif;\n  font-weight: 600;\n  font-size: var(--font-size-14);\n  line-height: var(--line-height-20);\n  color: var(--secondarycolors-blue400);\n  padding: 0;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n\n.scl--cms-components-inboxChart-openBtn:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
